import apiResource from '@/services/http/api/resource';
import router from '@/router';
import getProperty from '@/utils/getProperty';
import storage from '@/services/storage';
import ROUTE_NAMES from '@/constants/routeNames';

let abortController = null;

const defaultState = () => {
    return {
        families: [],
        bubbleName: '',
        bubbleId: null,
        familiesAmount: null,
        loader: null,
        filter: {
            warehouseId: -1,
            categoryId: -1,
            isDifficult: -1,
            offset: 1,
            limit: 20
        },
        resourceFilter: null,
        resourceLoader: null,
        filterLoader: null,
        savedPosition: { x: 0, y: 0 }
    };
};

export default {
    namespaced: true,
    state: defaultState(),
    getters: {
        getFamilies: state => state.families,
        getBubbleName: state => state.bubbleName,
        getLoader: state => state.loader,
        getFamiliesAmount: state => state.familiesAmount,
        getFilter: state => state.filter,
        getResourceFilter: state => state.resourceFilter,
        getFilterLoader: state => state.filterLoader,
        getResourceLoader: state => state.resourceLoader,
        getBubbleId: state => state.bubbleId,
        getScrollSavedPosition: state => state.savedPosition
    },
    mutations: {
        setFamilies (state, payload) {
            state.families = payload;
        },
        setBubbleName (state, payload) {
            state.bubbleName = payload;
        },
        setFamiliesAmount (state, payload) {
            state.familiesAmount = payload;
        },
        setLoader (state, payload) {
            state.loader = payload;
        },
        setFilter (state, payload) {
            for (const prop in state.filter) {
                if (getProperty(state.filter, prop)) {
                    state.filter[prop] = getProperty(payload, prop) || state.filter[prop];
                }
            }
            storage.set(storage.keys.filter, JSON.stringify(state.filter));
        },
        setResourceFilter (state, payload) {
            state.resourceFilter = payload;
        },
        setResourceFilterLoader (state, payload) {
            state.resourceLoader = payload;
        },
        setFilterLoader (state, payload) {
            state.filterLoader = payload;
        },
        clear (state) {
            state.families = defaultState().families;
            state.familiesAmount = defaultState().familiesAmount;
            state.loader = defaultState().loader;
        },
        clearBubbleName (state) {
            state.bubbleName = defaultState().bubbleName;
        },
        cancelGetFamilies () {
            abortController.abort('Canceled: new filter');
        },
        setBubbleId (state, payload) {
            state.bubbleId = payload;
            storage.set(storage.keys.bubble, payload);
        },
        setScrollSavedPosition (state, payload) {
            state.savedPosition = payload;
        }
    },
    actions: {
        getFamilies (context, payload) {
            let isCanceled = false;

            abortController = new AbortController();

            if (storage.get(storage.keys.filter) != null) {
                context.commit('setFilter', JSON.parse(storage.get(storage.keys.filter)));
            }

            apiResource.getFamilies(payload, context.getters.getFilter, {
                signal: abortController.signal
            }).then(({ data }) => {
                context.commit('setFamilies', data.data.families);
                context.commit('setBubbleName', data.data.name);
                context.commit('setFamiliesAmount', data.data.count);
                return data.data;
            }).catch((error) => {
                if (error.response && error.response.status === 404) {
                    router.replace({ name: ROUTE_NAMES.NOT_FOUND });
                }
                if (abortController.signal.aborted) {
                    isCanceled = true;
                } else {
                    context.commit('setFamilies', []);
                }
            }).finally(() => {
                context.commit('setLoader', false);
                if (!isCanceled) {
                    context.commit('setFilterLoader', false);
                }
            });
        },
        getResourceFilter (context, payload) {
            context.commit('setResourceFilterLoader', true);

            apiResource.getResourceFilter(payload).then(({ data }) => {
                context.commit('setResourceFilter', data.data);
            }).finally(() => {
                context.commit('setResourceFilterLoader', false);
            });
        },
        resetFilter (context) {
            context.commit('setFilter', {
                categoryId: defaultState().filter.categoryId,
                warehouseId: defaultState().filter.warehouseId,
                isDifficult: defaultState().filter.isDifficult,
                offset: defaultState().filter.offset
            });
        },
        resetPagination (context) {
            context.commit('setFilter', {
                offset: defaultState().filter.offset,
                limit: defaultState().filter.limit
            });
        }
    }
};
